/**
 * @fileoverview SessionCard Body Component
 * 
 * Displays the body section of a session card containing the video feed
 * and optional loading overlay.
 * 
 * @module vtc/components/SessionCard/SessionCardBody
 */

import { Mask, Spinner } from '@instructure/ui';
import { Text, View } from '@smarterservices/smarter-ui';
import Card from '../Common/Card';
import { SessionViewerPortal } from '../../contexts/SessionViewerContext';
import Overlays from '../Overlays';

/**
 * SessionCardBody Component
 * 
 * Renders the body section with video feed and loading overlay.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {string} props.cardViewer - Session SID for the viewer portal
 * @param {boolean} props.showLoader - Whether to show loading overlay
 * @param {string} props.loaderMessage - Message to display in loader
 * @returns {JSX.Element}
 */
function SessionCardBody({ sessionSid, cardViewer, showLoader, loaderMessage }) {
  return (
    <Card.Body>
      <View
        as="div"
        id="SessionBody"
        height="100%"
        padding="none none xxx-small none"
        style={{ position: 'relative' }}
      >
        {/* SessionViewer Portal - Renders the viewer from SessionViewerContext */}
        <SessionViewerPortal sessionSid={cardViewer} isFocused={false} />

        {/* Loading overlay - Shown during initial load and reconnection 
        {showLoader && (
          <Mask
            placement="center"
            themeOverride={{
              zIndex: 5000,
              background: 'rgba(255, 255, 255, 0.60)',
            }}
          >
            <Spinner renderTitle="Loading" size="small" />
            <View as="div">
              <Text size="large" color="secondary-inverse">
                {loaderMessage}
              </Text>
            </View>
          </Mask>
        )}
        */}
      </View>
      <Overlays sessionSid={sessionSid} />
    </Card.Body>
  );
}

export default SessionCardBody;
